import React, { useMemo } from 'react';
import { withStyles } from '@material-ui/core';
import DeliveryReceiptDetailsDefault from '../DefaultExceptionFlow/DeliverReceiptDetails';
import ExceptionNumberDisplay from '../common/ExceptionNumberDisplay';

const styles = (theme) => ({
  adeNumberContainer: {
    marginBottom: 12
  },
  adeNumberContainerNoMargin: {
    marginBottom: 0
  }
});

const hasDefaultRowData = (ex = {}) => {
  return Boolean(ex?.code) && Boolean(ex?.pieces) && Boolean(ex?.packageType) && Boolean(ex?.description);
};

const DeliveryReceiptDetailsBoth = ({
  exceptionDetails, // full array: [{adeNumber:123,code:123,pieces:123,packageType:123,description:123},...]
  packageTypeList,
  getExceptionDescription,
  isMultipleExceptionsEnabled,
  DispatchStore,
  classes
}) => {
  const exceptions = Array.isArray(exceptionDetails) ? exceptionDetails : [];

  // BOTH flow structure: [{adeNumber:123,code:123,pieces:123,packageType:123,description:123},...]
  // All exceptions have the same adeNumber embedded
  // Extract adeNumber from first exception that has it
  const adeNumber = useMemo(() => {
    const firstWithADE = exceptions.find(ex => ex?.adeNumber != null);
    return firstWithADE?.adeNumber || null;
  }, [exceptions]);

  // Filter to only show exceptions with complete default data, and remove adeNumber for display
  const defaultExceptions = useMemo(() => {
    return exceptions
      .filter(ex => hasDefaultRowData(ex)) // Only show complete exceptions
      .map(ex => {
        // Remove adeNumber for display
        return Object.keys(ex).reduce((acc, key) => {
          if (key !== 'adeNumber') {
            acc[key] = ex[key];
          }
          return acc;
        }, {});
      });
  }, [exceptions]);

  const showADE = Boolean(adeNumber);
  const showDefault = defaultExceptions.length > 0;
  return (
    <>
      {/* Show ADE Number if provided (optional field) */}
      {showADE ? (
        <div className={showDefault ? classes.adeNumberContainer : classes.adeNumberContainerNoMargin}>
          <ExceptionNumberDisplay 
            adeNumber={adeNumber} 
            DispatchStore={DispatchStore} 
          />
        </div>
      ) : null}

      {/* Show Default exceptions if present */}
      {showDefault
        ? defaultExceptions.map((ex, idx) => (
            <DeliveryReceiptDetailsDefault
              key={idx}
              index={idx}
              exceptionDetails={ex}
              packageTypeList={packageTypeList}
              getExceptionDescription={getExceptionDescription}
              isMultipleExceptionsEnabled={isMultipleExceptionsEnabled}
            />
          ))
        : null}
    </>
  );
};

export default withStyles(styles)(DeliveryReceiptDetailsBoth);
